import FilterRegister from "../../../../components/filter/register-basic";
import reqInstagram from "../../../../services/reqMultiTenant/reqInstagram";
import { RegisterProvider } from "../../register-matrix/context-api";
import MainRegisterMatrix from "../../register-matrix/main";
import FormWhatsApp from "../form";

const MainRegisterInstagram = () => {
	const options = {
		id: "id_instagram", //usado para saber qual field usar para atualizar
		ident: "instagramConnect", //usado para definir os event listners
		identFilter: "filterInstagram", //usado para definir os event listners
		title: "Instagram Instância",
		subTitle: "Cadastro",
		tableColumns: [
			{ key: "descricao", label: "Nome da instância", align: "left", width: "250px" },
			// { key: "telefone", label: "Telefone", align: "left" },
			{ key: "actions", label: "", align: "right" },
		],
		hasActive: true,
		parametersFilter: [{ id: 1, label: "Nome do usuário", value: "descricao" }],
	};

	//#region Funções de acesso a dados do componente
	const fetch = async (filterData, newPage) => {
		const { param, paramValue, active } = filterData; //contem active que retorna true ou false

		const responseComplement = await reqInstagram.listPaginate(param, paramValue, active, newPage);

		return responseComplement;
	};

	const fetchID = async (currentId) => {
		const responseComplement = await reqInstagram.listID(currentId);

		return responseComplement;
	};

	const insert = async (data) => {
		const response = await reqInstagram.insert(data);

		return response;
	};

	return (
		<RegisterProvider options={options} fetch={fetch} fetchID={fetchID} insert={insert}>
			<MainRegisterMatrix FormComponent={FormWhatsApp} FormFilter={FilterRegister} />
		</RegisterProvider>
	);
};

export default MainRegisterInstagram;
